import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ExecutionService, FilesService, ToastService, ExecutionFormService } from 'src/app/services';
import { Execution, SubTool, SectionByTool, SectionFileData } from 'src/app/models';
import {
  FileConfig,
  TabsConfiguration,
  SubToolInfo, TabSection,
  Tabs, DiscountingConfig,
  ConfigurationEvent,
  FileOptions,
  TabsTool,
  TemplatesTaxonomy,
  TemplatesTaxonomyCheck} from 'src/app/models/tool.model';
import { ToolType } from 'src/app/resources/tool-utils';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NewFundModalComponent } from '../new-fund-modal/new-fund-modal.component';
import { AddSetModalComponent, AddSetModalValue } from './add-set-modal/add-set-modal.component';


@Component({
    selector: 'app-add-edit-execution',
    templateUrl: './add-edit-execution.component.html',
    styleUrls: ['./add-edit-execution.component.scss'],
    standalone: false
})
export class AddEditExecutionComponent implements OnInit {

  idExecution: string;
  typeExecution: string;
  execution: Execution;
  subTools: SubTool[];
  tabsConfiguration: TabsConfiguration;
  tabs: TabsTool;
  configurations: FileConfig[];
  keys: string[];
  selectedKey: string;
  activeIndexTab: number;
  listCurrency: string[];
  actualList: SectionByTool[];
  validationText: string;
  subToolsAvailable: SubToolInfo[] = [];
  isTemplateFill = true;

  // TODO chiedere se al cambio di template i file devono rimanere nelle sezioni
  toDeleteSection: SectionByTool[] = [];
  isTemplateFillChanged = false;
  chunkCount = 0;
  collapsed = false;
  templatesTaxonomyList: TemplatesTaxonomy = {};
  templatesTaxonomyCheck: TemplatesTaxonomyCheck = {};

  addTab: (value: string) => void;

  constructor(
    private executionService: ExecutionService,
    private filesService: FilesService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private toastService: ToastService,
    private efs: ExecutionFormService,
  ) {
    this.addTab = this.addTagPromise.bind(this);
  }

  async ngOnInit() {
    this.route.paramMap.subscribe(async (params) => {
      this.idExecution = params.get('id');
      try {
        this.tabsConfiguration = (await this.filesService.getSectionsByTool(this.idExecution));
        this.tabs = this.tabsConfiguration.tabs;
        this.configurations = this.tabsConfiguration.configurations;
        this.keys = Object.keys(this.tabs);
        this.selectedKey = this.keys[0];
        this.activeIndexTab = 0;

        this.efs.patchTabEditableSelectValues(this.tabs, this.selectedKey);
        this.efs.patchConfigurationEditableSelectValues(this.configurations);

        this.execution = await this.executionService.getToolInfo(this.idExecution);
        this.typeExecution = this.execution.name_tool;

        if (this.updateSubTool() && this.typeExecution === ToolType.ESG) {
          (this.tabs[this.selectedKey] as Tabs).sections.map(section => section.file_categories.map(item => {
            if (item.data.length > 0) {
              this.efs.handleClass(section);
            }
          }));
        }
      } catch (error) {
        this.toastService.showError(error.error);
        console.error('error =>', error);
      }
    });
  }

  async updateTabsConfig(addNewSet?: AddSetModalValue, activeIndexTab?: number) {
    try {
      this.tabsConfiguration = (await this.filesService.getSectionsByTool(this.idExecution, addNewSet?.currencyValue));
      this.tabs = this.tabsConfiguration.tabs;
      this.configurations = this.tabsConfiguration.configurations;
      this.keys = Object.keys(this.tabs);
      if (addNewSet && addNewSet.currencyValue) {
        this.selectedKey = addNewSet.currencyValue;
        this.activeIndexTab = this.keys.length - 1;
      } else {
        if (activeIndexTab !== null && activeIndexTab !== undefined) {
          if (activeIndexTab >= this.keys.length) {
            this.selectedKey = this.keys[this.keys.length - 1];
            this.activeIndexTab = this.keys.length - 1;
          } else if (activeIndexTab === 0) {
            this.selectedKey = this.keys[0];
            this.activeIndexTab = 0;
          } else {
            this.selectedKey = this.keys[activeIndexTab];
            this.activeIndexTab = activeIndexTab;
          }
        } else {
          this.selectedKey = this.keys[this.keys.length - 1];
          this.activeIndexTab = this.keys.length - 1;
        }
      }
      if (addNewSet?.currencyValue) {
        this.efs.updateRR(this.tabs, this.selectedKey, addNewSet.recoveryRateValue);
      }
    } catch (error) {
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }

  async updateSubTool() {
    try {
      this.subTools = (await this.executionService.getAvailableSubTool(this.idExecution)).section_list;
      if (this.subTools[0].subtool_list[0].subtool_available && this.subTools.length > 1) {
        this.subToolsAvailable = this.subTools[1].subtool_list.filter(subTool => subTool.subtool_available);
        return true;
      }
      return false;
    } catch (error) {
      this.toastService.showError(error.error);
      console.error('error =>', error);
      return false;
    }
  }

  async getFileFromInput(event: FileList, section: SectionByTool, sectionListType: string) {
    const ctx = { chunkCount: this.chunkCount, isTemplateFill: this.isTemplateFill, toDeleteSection: this.toDeleteSection };
    await this.efs.uploadFiles(event, section, sectionListType, this.idExecution, this.selectedKey, this.tabs, this.typeExecution, ctx, () => this.updateSubTool());
    this.chunkCount = ctx.chunkCount;
    this.isTemplateFill = ctx.isTemplateFill;
    this.toDeleteSection = ctx.toDeleteSection;
  }

  deleteData(el: SectionFileData, section: SectionByTool) {
    this.efs.deleteData(el, section, () => this.updateSubTool());
  }

  getSelected(selected: string, index: number) {
    this.selectedKey = selected;
    this.efs.patchTabEditableSelectValues(this.tabs, this.selectedKey);
    this.activeIndexTab = index;
  }

  async getSelectedConfig(event: ConfigurationEvent) {
    const result = await this.efs.getSelectedConfig(
      this.idExecution,
      event,
      { templatesTaxonomyList: this.templatesTaxonomyList, isTemplateFill: this.isTemplateFill, isTemplateFillChanged: this.isTemplateFillChanged, toDeleteSection: this.toDeleteSection },
      () => this.updateSubTool(),
    );
    this.isTemplateFillChanged = result.isTemplateFillChanged;
  }

  async setTemplatesTaxonomyList(event: TemplatesTaxonomy) {
    this.templatesTaxonomyList = event;
  }

  async setTemplatesTaxonomyCheck(event: TemplatesTaxonomyCheck) {
    this.templatesTaxonomyCheck = event;
  }

  async getSingleTabConfig(tabsConfiguration: FileConfig) {
    await this.efs.getSingleTabConfig(this.idExecution, tabsConfiguration, this.selectedKey, () => this.updateSubTool());
  }

  async addTagPromise(value: string, name: string, tabId: string, validate?: boolean) {
    const result = await this.efs.addTagPromise(this.idExecution, value, name, tabId, validate);
    this.validationText = result.validationText;
    if (!result.validationText) {
      this.updateSubTool();
    }
    return result.value;
  }

  addCurrency(name: string) {
    return this.efs.addCurrency(name);
  }

  async addSetModal() {
    try {
      const tabsConfiguration = JSON.parse(JSON.stringify(this.tabs[this.selectedKey]));
      const listCurrencies = (await this.filesService.getAvailableCurrencies(this.idExecution)).currency_list;
      const currenciesValue = listCurrencies.map((item): FileOptions => {
        return { id: item.id, value: item.value, isChecked: false };
      });
      tabsConfiguration.tab_configuration.map((config: FileConfig) => {
        config.choosen_value = undefined;
        config.values = currenciesValue;
        return config;
      });
      const modalRef = this.modalService.open(AddSetModalComponent, { centered: true, size: '50%', backdrop: 'static' });
      modalRef.componentInstance.tabs = tabsConfiguration;
      modalRef.componentInstance.idExecution = this.idExecution;
      modalRef.componentInstance.closeModal.subscribe(async (set: {tabsConfig: DiscountingConfig[], activeModal: NgbActiveModal}) => {
        await this.filesService.createNewSet(this.idExecution, set.tabsConfig);
        set.activeModal.close();
        this.updateTabsConfig();
        this.updateSubTool();
        this.collapsed = true;
      });
    } catch (error) {
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }

  handleCollapse($event: Event) {
    this.efs.handleCollapse($event);
  }

  handleClass(section: TabSection) {
    this.efs.handleClass(section);
  }

  getToolName(index?: number, isDelete?: boolean) {
    return this.efs.getToolName(this.typeExecution, index, isDelete);
  }

  async checkToggle(value: FileConfig, boxIndex: number, sectionIndex: number) {
    await this.efs.checkToggle(this.idExecution, this.tabs, this.selectedKey, value, boxIndex, sectionIndex, () => this.updateSubTool());
  }

  async addStressTypeYes() {
    try {
      await this.filesService.createNewStress(this.idExecution, this.selectedKey);
      await this.updateTabsConfig(null, this.activeIndexTab);
      await this.updateSubTool();
      this.collapsed = true;
      setTimeout(() => {
        const el = document.querySelector('#input-section-container-' + (this.tabs[this.selectedKey].sections.length - 1));
        el.scrollIntoView({ behavior: 'smooth' });
      }, 0);
    } catch (error) {
      console.error('error =>', error.error);
      this.toastService.showError(error.error);
    }
  }

  getTabConfiguration() {
    return this.efs.getTabConfiguration(this.tabs, this.selectedKey);
  }

  openTabsCollapse() {
    this.collapsed = false;
  }

  public async sendConfigurationDataToBE(selectedValue: FileOptions, selectedConfig: FileConfig): Promise<void> {
    await this.efs.sendConfigurationDataToBE(this.idExecution, selectedValue, selectedConfig);
  }

  public async sendConfigurationDataValueNameToBE(selectedValue: any, selectedConfig: FileConfig): Promise<void> {
    await this.efs.sendConfigurationDataValueNameToBE(this.idExecution, selectedConfig);
  }

  createNewFund() {
    const modalRef = this.modalService.open(NewFundModalComponent, { centered: true, size: '50%', backdrop: 'static' });
    const newFundConfig = JSON.parse(JSON.stringify(this.tabs[this.selectedKey]));
    newFundConfig.tab_configuration.map((config: FileConfig) => {
      config.choosen_value = undefined;
      return config;
    });
    modalRef.componentInstance.tabsConfig = newFundConfig.tab_configuration;
    modalRef.componentInstance.fundSubmit.subscribe(async (createdFund: {tabsConfig: FileConfig[], activeModal: NgbActiveModal}) => {
      const createFundBody: DiscountingConfig[] = createdFund.tabsConfig.map(item => {
        return { name: item.name, value: item.choosen_value };
      });
      try {
        await this.filesService.createNewFund(this.idExecution, createFundBody);
        createdFund.activeModal.close();
        this.updateTabsConfig();
        this.updateSubTool();
      } catch (error) {
        console.error('error =>', error.error);
        this.toastService.showError(error.error);
      }
    });
  }

  async removeStressYes(id: string, type: string) {
    try {
      await this.filesService.removeStressType(this.idExecution, id, type);
      this.updateTabsConfig(null, this.activeIndexTab);
      this.updateSubTool();
    } catch (error) {
      console.error('error =>', error.error);
      this.toastService.showError(error.error);
    }
  }

  async getSectionConfigValue(selectedValue: FileOptions, selectedConfig: FileConfig) {
    await this.efs.getSectionConfigValue(this.idExecution, selectedValue, selectedConfig);
  }

  returnShowClass() {
    return this.efs.returnShowClass(this.typeExecution);
  }
}
